module.exports = __webpack_public_path__ + "static/media/american-categories.a41fd613.jpg";